module.exports = __webpack_public_path__ + "img/menuNav.cec39e38.png";